import { render, staticRenderFns } from "./DynamicAttributeSourceKey.vue?vue&type=template&id=3a3ae2d5&"
import script from "./DynamicAttributeSourceKey.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeSourceKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports